import { useEffect, useState } from "react";

function isNearApplySection(target) {
  const rect = target.getBoundingClientRect();
  const viewportHeight = window.innerHeight || 0;
  if (!viewportHeight) return false;
  const visible = Math.min(rect.bottom, viewportHeight) - Math.max(rect.top, 0);
  const occupying = visible / viewportHeight;
  const approaching = rect.top <= viewportHeight - 96;
  return approaching || occupying >= 0.22;
}

function cookieBannerRise() {
  const banner = document.querySelector('[aria-label="Informasjonskapsler"]');
  if (!banner) return 0;
  const box = banner.getBoundingClientRect();
  if (box.height < 8) return 0;
  return Math.round(box.height + 12);
}

export function JobApplyDock({ enabled }) {
  const [hidden, setHidden] = useState(false);
  const [hasTarget, setHasTarget] = useState(false);
  const [rise, setRise] = useState(0);

  useEffect(() => {
    if (!enabled) {
      setHasTarget(false);
      document.body.classList.remove("has-apply-dock");
      return undefined;
    }

    const target = document.getElementById("soknad");
    if (!target) {
      setHasTarget(false);
      document.body.classList.remove("has-apply-dock");
      return undefined;
    }

    setHasTarget(true);
    document.body.classList.add("has-apply-dock");

    const update = () => {
      setHidden(isNearApplySection(target));
      setRise(cookieBannerRise());
    };
    update();
    window.addEventListener("scroll", update, { passive: true });
    window.addEventListener("resize", update);
    const observer = new IntersectionObserver(update, {
      threshold: [0, 0.2, 0.3, 0.5, 1],
      rootMargin: "0px 0px 24% 0px",
    });
    observer.observe(target);
    const mutations = new MutationObserver(update);
    mutations.observe(target.parentElement || target, {
      childList: true,
      subtree: true,
    });

    return () => {
      window.removeEventListener("scroll", update);
      window.removeEventListener("resize", update);
      observer.disconnect();
      mutations.disconnect();
      document.body.classList.remove("has-apply-dock");
    };
  }, [enabled]);

  if (!enabled || !hasTarget) return null;

  return (
    <button
      type="button"
      className={`apply-dock${hidden ? " is-hidden" : ""}`}
      style={{ "--apply-dock-rise": `${rise}px` }}
      onClick={() => {
        document.getElementById("soknad")?.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }}
      aria-hidden={hidden}
      tabIndex={hidden ? -1 : 0}
    >
      Søk stilling lengre ned
      <span className="arr" aria-hidden="true">
        ↓
      </span>
    </button>
  );
}
